<template>
  <div class="c-config-content">
    <h4>{{ $t('recording') }}</h4>
    <div>
      <div>
        <table class="table table-hover thead-dark">
          <thead>
          <tr style="background-color: #F1F5FB">
            <th colspan="2">{{ $t('recordingName') }}</th>
          </tr>
          </thead>
          <tbody v-if="items.length">
          <tr v-for="item in items" :key="item._id">
            <td class="align-middle">{{ item.name }}</td>
            <td>
              <audio v-if="item.hash" controls>
                <source :src="item.hash" type="audio/mp3">
              </audio>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="3" class="text-center text-gray-999">{{ $t('noRecordingFound') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';

export default {
  props: ['client'],
  mixins: [list, crud],
  data: function () {
    return {
      service: '/recording',
      autoLoad: true,
      defaultFilterFormModel: {
        client: this.client._id
      }
    }
  },
  i18n: {
    messages: {
      vi: {
        recording: "File ghi âm",
        recordingName: "Tên file ghi âm",
        noRecordingFound: "Chưa có file ghi âm nào"
      },
      en: {
        recording: "File ghi âm",
        recordingName: "Tên file ghi âm",
        noRecordingFound: "Chưa có file ghi âm nào"
      }
    }
  }
}
</script>